import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

import {
  FAQListing,
  StaticContent,
  StaticContentModel,
  FAQListingQueryParameters,
  NotificationPreferencesData,
} from "./type";

const initialState: StaticContentModel = {
  staticContent: {
    _id: "",
    type: "",
    content: "",
  },

  notificationPreferencesData: {
    _id: "",
    reviewRemainderStatus: false,
    pushNotificationStatus: false,
    accountNotificationStatus: false,
    announcementNotificationStatus: false,
  },

  faqListing: {
    data: [],
    total: 0,
    limit: 0,
    pageNo: 0,
    nextHit: 0,
    totalPage: 0,
  },

  faqListingQueryParameters: {
    pageNo: 1,
    limit: 10,
  },
};

const StaticContentSlice = createSlice({
  name: "StaticContent",
  initialState,
  reducers: {
    setStaticContent: (
      state: StaticContentModel,
      action: PayloadAction<StaticContent>,
    ) => {
      state.staticContent = action.payload;
    },

    setUserNotificationPreferences: (
      state: StaticContentModel,
      action: PayloadAction<NotificationPreferencesData>,
    ) => {
      state.notificationPreferencesData = action.payload;
    },

    setFaqListing: (
      state: StaticContentModel,
      action: PayloadAction<FAQListing>,
    ) => {
      if (action.payload.data && action.payload.data.length === 0) {
        state.faqListing.data = [...action.payload.data];
      } else {
        state.faqListing.data = [
          ...state.faqListing.data,
          ...action.payload.data,
        ];
      }
      state.faqListing.total = action.payload.total;
      state.faqListing.limit = action.payload.limit;
      state.faqListing.pageNo = action.payload.pageNo;
      state.faqListing.nextHit = action.payload.nextHit;
      state.faqListing.totalPage = action.payload.totalPage;
    },

    setFaqListingQueryParameters: (
      state: StaticContentModel,
      action: PayloadAction<FAQListingQueryParameters>,
    ) => {
      state.faqListingQueryParameters = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setFaqListing,
  setStaticContent,
  setUserNotificationPreferences,
  setFaqListingQueryParameters,
} = StaticContentSlice.actions;

export default StaticContentSlice.reducer;
